module.exports = __webpack_public_path__ + "img/visa.6be39290.png";